module.exports = __webpack_public_path__ + "img/globe.a9c48360.svg";